function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#66CEEF;}\n\t.st1{fill:#1A87C7;}\n\t.st2{fill:#BDEDF8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M755.1,175c1.4-0.8,2.8-1.2,4.2-1.8l1.4-0.8l-13.6-7l-2-0.2l-7.2,1.4l-5.8,2.8l-85.4,49.4 c5.6,3.2,10.8,6.6,15.6,10L755.1,175z"
}), React.createElement("path", {
  className: "st0",
  d: "M744.3,494.2l-4.2,12.4l-8.8,15.4l-8.6,9.8l-3,2.2v19.2l22.8-13.6c0.4-0.4,0.8-0.8,1.2-1.2l8-9.6 c0.4-0.6,0.8-1,1-1.6l3.8-7.6c1-2.2,2.2-4.4,2.8-6.6l1.6-6.8c0.6-2.8,1.2-5.6,1.2-8v-0.4l-1.2-270c0-0.2-0.2-0.6-0.2-0.8l-4.4-5.8 l0,0c-3-1.6-6.6-1-10.6,0.4v259.8L744.3,494.2z"
}), React.createElement("polygon", {
  className: "st1",
  points: "733.3,484.8 730.3,498.4 723.5,511.8 719.7,516.4 719.7,526.4 721.1,525 723.7,521.8 726.3,518.8  728.5,515.2 730.7,511.8 732.7,508.2 734.5,504.4 735.9,500.8 737.3,497 738.3,493.2 739.1,489.4 739.5,485.6 739.7,481.8  739.7,224.6 732.3,228.8 733.5,481.6  "
}), React.createElement("path", {
  className: "st1",
  d: "M729.3,163.8l3.6-1.8l3.4-1.4l3.4-1l3.2-0.4h3l2.8,0.4l2.6,0.8l2.4,1.2l15.2,8.8c6-1,11.8-0.2,16.8,2.6 l-29.2-16.8l-3.4-1.6l-7.4-1.4l-4,0.2l-7.8,1.8l-100,56.8c2.2,1,4.4,2.2,6.4,3.4L729.3,163.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M739.5,485.6l-0.4,3.8l-0.8,3.8l-1,3.8l-1.4,3.8l-1.6,3.8l-1.8,3.8l-2,3.6l-2.2,3.4l-2.4,3.4l-2.6,3.2l-2.6,3 l-1.4,1.4v8l3-2.2l8.6-9.8l8.8-15.4l4.2-12.4l1.6-12.4V222.4c-1.6,0.6-3,0.8-4.6,1.8l-1.4,0.8v257.2V485.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M756.5,221.8l4.4,5.8C759.9,225,758.5,222.8,756.5,221.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M751.7,529.2l-8,9.6C746.5,536,749.3,532.8,751.7,529.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M719.7,554.6l15.2-8.8c2.6-1.4,5-3.4,7.6-5.8l-22.8,13.6V554.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M646.9,218.6l85.4-49.4l5.8-2.8l7.2-1.4l2,0.2l13.6,7l-1.6,1c3.4-1.6,6.6-2.6,9.8-3l-15.2-8.8l-2.4-1.2 l-2.6-0.8l-2.8-0.4h-3l-3.2,0.4l-3.4,1l-3.4,1.4l-3.6,1.8l-89,51.4c2,1,4,2,6,3C646.5,218.4,646.7,218.4,646.9,218.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M762.3,236c0-3-0.4-5.4-1.2-7.6l1.2,270V236z"
}), React.createElement("path", {
  className: "st1",
  d: "M754.1,525.4c1-1.8,1.4-3.6,2.4-5.4l-3.8,7.6C753.1,526.8,753.7,526.21,754.1,525.4z"
}), React.createElement("polygon", {
  className: "st1",
  points: "762.3,498.4 762.3,498.2 762.3,498.6  "
}), React.createElement("path", {
  className: "st1",
  d: "M760.9,506.6l-1.6,6.8C760.1,511,760.5,508.8,760.9,506.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M785.7,172.6c2.8,1.6,3.8,5.2,2.4,8.2c-0.2,0.4-0.8,0.6-1,0.8c3.6,4.2,5.8,10.6,5.8,18.8v305.2 c0,11-3.8,23.4-10.2,34.2l0,0c-6.2,10.8-15,20.4-24.6,25.8l-38.4,22.2v7.2l41.6-24c10.2-5.8,19.6-15.8,26.8-28.2 c7-12.2,11-25.4,11-37.2V200.4C798.9,187.4,794.3,177.6,785.7,172.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M690.7,252.8l41.8-24v-7l-46.2,26.6C687.5,250,689.3,251.4,690.7,252.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.5,228.6L662.5,228.6l96.8-55.4c-1.4,0.6-2.8,1-4.2,1.8L662.5,228.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M758.9,515l0.4-1.6c-0.8,2.2-1.8,4.4-2.8,6.6L758.9,515z"
}), React.createElement("path", {
  className: "st1",
  d: "M743.1,539.6l0.6-0.8c-0.4,0.4-0.8,0.8-1.2,1.2L743.1,539.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M752.3,528.4l0.4-0.8c-0.4,0.6-0.8,1-1,1.6L752.3,528.4z"
}), React.createElement("polygon", {
  className: "st1",
  points: "756.5,221.6 756.5,221.6 756.5,221.8  "
}), React.createElement("path", {
  className: "st1",
  d: "M761.1,227.8l-0.2-0.2c0,0.2,0.2,0.4,0.2,0.8V227.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M762.1,501.4v-2.8c0,2.4-0.8,5.4-1.2,8L762.1,501.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M756.5,221.6l-10.8-6.2l0.2,3.6v3C749.7,220.6,753.5,220.2,756.5,221.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M768.3,498.4v1.4C768.3,499.4,768.5,499,768.3,498.4V235.8c0-0.4,0-0.8-0.2-1.2v1.2L768.3,498.4L768.3,498.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M766.1,223.8c0-0.2-0.2-0.2-0.2-0.4L766.1,223.8L766.1,223.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M739.7,224.6v-5.2v-1.6c-0.6,0.2-1,0.4-1.6,0.8l-5.8,3.4v7L739.7,224.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M768.9,170.2l13.6,7.8c1.6,1,3.2,2.2,4.4,3.8c0.4-0.4,0.8-0.4,1-0.8c1.6-3,0.6-6.6-2.4-8.2 C780.7,169.8,775.1,169.2,768.9,170.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M765.9,513.8c0-0.2,0-0.2,0.2-0.4v0.2L765.9,513.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M719.7,561.8L719.7,561.8l18.4-10.6c0.2-0.2,0.6-0.4,0.8-0.6l-0.8,0.6L719.7,561.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M749.5,541.8c0.2-0.2,0.4-0.4,0.6-0.6l-0.2,0.2L749.5,541.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.9,229.6c0-0.2,0-0.4-0.2-0.6v0.4L767.9,229.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M744.1,546.8L744.1,546.8C743.9,547,744.1,547,744.1,546.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M777.5,176l-2.8-0.4h-3l-3.2,0.6l-3.4,0.8l-3.4,1.4l-3.6,1.8c9.6-5.4,18.2-6,24.6-2.4l-2.4-1.2L777.5,176z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.7,506.2c0-0.2,0-0.6,0.2-0.8v0.4L767.7,506.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M739.7,224.6l1.4-0.8c1.6-1,3.2-1.2,4.6-1.8v-3l-0.2-3.6l10.8,6.2l0,0v0.2c2,1.2,3.4,3.2,4.4,5.8l0.2,0.2v0.4 c0.6,2.2,1.2,4.8,1.2,7.6v262.4v0.2l0,0v2.8l-1.2,5.2c-0.4,2.2-0.8,4.4-1.6,6.8l-0.4,1.6l-2.6,5c-0.8,1.8-1.4,3.6-2.4,5.4 c-0.4,0.8-1,1.4-1.4,2.2l-0.4,0.8l-0.6,0.8c-2.4,3.6-5,6.8-8,9.6l-0.6,0.8l-0.6,0.4c-2.4,2.2-5,4.2-7.6,5.8l-15.2,8.8v7.2 l18.4-10.6l0.8-0.6c1.8-1,3.4-2.2,5-3.6l0.2-0.2c1.8-1.6,3.6-3.2,5.4-5l0.2-0.4l0.2-0.2c3.6-3.8,6.8-8.2,9.4-12.8 c2.8-4.6,5-9.6,6.4-14.6v-0.2v-0.2c0.8-2.4,1.2-4.8,1.6-7v-0.4v-0.4c0.2-2,0.4-3.8,0.4-5.6v-1.4V236v-1.2c0-1.8-0.2-3.6-0.4-5.2 v-0.4v-0.4c-0.4-1.8-1-3.6-1.6-5v-0.2l-0.2-0.2c-1.6-3.2-3.8-5.6-6.4-7.2c-0.2-0.2-0.4-0.2-0.6-0.2c-5.2-2.6-12-2.2-19.4,1.6v1.6 v5.4C738.9,224.6,739.7,224.6,739.7,224.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.5,228.6c1.8,1.4,3.6,2.6,5.2,4l90.4-52.2l3.6-1.8l3.4-1.4l3.4-0.8l3.2-0.6h3l2.8,0.4l2.6,0.8l2.4,1.2 l-13.6-7.8c-3.2,0.6-6.4,1.6-9.8,3L662.5,228.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M779.9,183.6L779.9,183.6c4.2,2.6,6.8,8.8,6.8,17v305.2c0,9.6-3.4,20.8-9.4,31.2c-6,10.2-14,19-22.2,23.6 l-35.4,20.4v7.2l38.4-22.2c9.6-5.6,18.2-15,24.6-25.8l0,0c6.2-11,10.2-23.2,10.2-34.2V200.4c0-8.2-2.2-14.4-5.8-18.8 C785.3,183.8,782.5,184.8,779.9,183.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M761.9,536l-10.2,12.2C755.5,544.6,758.9,540.4,761.9,536z"
}), React.createElement("path", {
  className: "st1",
  d: "M732.3,221.8v-7.2L681.5,244c1.6,1.4,3,3,4.6,4.4L732.3,221.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M719.7,568.8L719.7,568.8l21.4-12.4c3.4-2,6.4-4.4,9.6-7.2l-9.4,7L719.7,568.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M771.1,517.6c2.2-6.6,3.6-13,3.6-19.2V236l0,0l-0.6,270.8L771.1,517.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M764.9,531.4c2-3.6,3.8-7.2,5.2-11l-7,13.8C763.7,533.4,764.3,532.4,764.9,531.4z"
}), React.createElement("polygon", {
  className: "st1",
  points: "727.7,205 727.7,205 672.9,236.6 672.9,236.6  "
}), React.createElement("path", {
  className: "st1",
  d: "M773.9,181.8l-1.2,0.2c0.6,0,1.4,0,2,0L773.9,181.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.7,183l-1,0.2l-5.8,2.8l-20.8,12l0,0l21.2-12.2C763.5,184.4,765.7,183.6,767.7,183z"
}), React.createElement("path", {
  className: "st1",
  d: "M761.5,217.6l1.8,1.8l1.4,2l1.2,2.2c0,0.2,0.2,0.2,0.2,0.4l1,2.4l0.8,2.6c0,0.2,0,0.4,0.2,0.6l0.4,2.8l0.2,2.2 c0,0.4,0.2,0.8,0.2,1.2v262.6c0,0.4-0.2,1-0.2,1.4v2.2l-0.4,3.4c0,0.2,0,0.6-0.2,0.8l-0.8,3.4l-1,3.6c0,0.2,0,0.2-0.2,0.4l-1.2,3.6 l-1.6,3.8l-1.8,3.8l-2,3.6l-2.2,3.6l-2.2,3.4l-2.6,3.2l-2.4,2.8c-0.2,0.2-0.4,0.4-0.6,0.6l-2.4,2.6l-2.8,2.6l0,0l-0.2,0.2l-2.8,2 l-2.2,1.4c-0.2,0.2-0.6,0.4-0.8,0.6L719.9,562v7l21.6-12.6l9.4-7c0.4-0.4,0.8-0.6,1.2-1l10.2-12.2c0.4-0.6,0.8-1.2,1-1.6l7-13.8 c0.4-1,0.8-2,1-3l2.8-11l0.6-270.8c0-11.4-4.4-20.6-12.8-25.4c-4.6-2.4-9.8-2.8-15.2-1.8l13,7.6L761.5,217.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.7,178c-6.2-3.6-15-3-24.6,2.4l-90.4,52.2c1.8,1.4,3.6,2.8,5.2,4l54.8-31.6l0,0l5.6-3.2l-0.8-0.8l-2-1.4 l3.2,1.8l6.2-3.6l0,0l20.8-12l6-2.6l1-0.2c1.8-0.6,3.4-0.8,5-1l1.2-0.2l0.8,0.2c1.8,0.2,3.4,0.4,4.8,1.2l0.2,0.2h0.2 c2.6,1.2,5.2,0.2,7-1.8C785.7,180.2,784.3,179,782.7,178z"
}), React.createElement("path", {
  className: "st1",
  d: "M738.1,218.4c0.6-0.4,1-0.4,1.6-0.8v-1.8l-0.4-3.2l-0.4-1.4c-1.2,0.6-2.4,1-3.8,1.8l-2.6,1.6v7.2L738.1,218.4z "
}), React.createElement("path", {
  className: "st1",
  d: "M768.3,232.4l-0.4-2.8c0.2,1.6,0.4,3.4,0.4,5.2V232.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M768.3,502.2V500c0,1.8-0.2,3.8-0.4,5.6L768.3,502.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M739.5,215.8v1.8c7.4-3.8,14.2-4.4,19.4-1.6c0.2,0,0.4,0.2,0.6,0.2c2.6,1.6,4.8,4,6.4,7.2l-1.2-2.2l-1.4-1.8 l-1.8-1.6l-2-1.4l-13-7.6c-2.6,0.4-5.2,1.4-7.8,2.6l0.4,1.4L739.5,215.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.1,509.6l0.8-3.4c-0.4,2.4-1,4.6-1.6,7L767.1,509.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M750.1,541.21l2.4-2.8l2.6-3.2l2.2-3.4l2.2-3.6l2-3.6l1.8-3.6l1.4-3.8l1.2-3.6c-1.6,5-3.8,10-6.4,14.6 C756.7,533.01,753.5,537.4,750.1,541.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M744.1,546.8l2.8-2.6l2.4-2.6C747.9,543.6,746.1,545.4,744.1,546.8L744.1,546.8z"
}), React.createElement("polygon", {
  className: "st1",
  points: "730.7,199.8 732.7,201 733.5,201.8 733.9,201.6  "
}), React.createElement("path", {
  className: "st1",
  d: "M741.1,549.01l2.8-2c-1.6,1.4-3.4,2.4-5,3.6L741.1,549.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M767.1,226.4l-1-2.4c0.6,1.6,1.2,3.2,1.6,5L767.1,226.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M405.9,865.6c-11-1.4-21.6-3.2-32-5.4C384.1,862.4,394.9,864.2,405.9,865.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M338.9,846.6v-2c-14.4-4.6-27.4-10-37.6-15.8c-63-36.4-66.4-54-69.4-81.6c-0.2-2.6-0.6-5.2-0.8-8v-385 c-4-10.4-6.2-21.2-6.2-32v411.4l0.8,14c3,30.2,8,49.2,72.4,86.4c11.8,6.8,27,12.8,44.4,18C340.5,851.21,338.9,849.2,338.9,846.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M625.9,844.2c-2.2,1-4.6,2-6.8,2.8c3.6-1.4,7.2-2.8,10.8-4.4c0,0-0.2,0-0.2,0.2 C628.3,843.2,627.1,843.8,625.9,844.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M607.1,851.4c-5.2,1.8-10.6,3.4-16.2,5c-1,0.2-2.2,0.6-3.2,0.8c-4.2,1.2-8.2,2.2-12.6,3.2 c-0.4,0.2-0.8,0.2-1.4,0.2c0,0,0,0-0.2,0c-30.4,6.6-63.4,9.8-96.4,9.8c-23.6,0-47.2-1.6-69.6-4.6c22.8,3,46.8,5,71.2,5 c46.8,0,94.2-6.4,134.2-21.2c-0.6,0.2-1.2,0.4-1.8,0.6C609.7,850.6,608.3,851,607.1,851.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M224.9,322.2L224.9,322.2L224.9,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M371.5,859.6c-8.4-1.8-16.6-3.8-24.4-6.2C354.9,855.8,363.1,857.8,371.5,859.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M304.3,823.4c-62-35.8-63.8-52.2-66.4-77l-0.6-378.6c-2.4-4.4-4.6-9-6.2-13.6v385c0.4,2.8,0.6,5.4,0.8,8 c2.8,27.8,6.4,45.4,69.4,81.6c10.2,6,23,11.2,37.6,15.8v-6.4C325.5,833.8,313.7,828.8,304.3,823.4z"
}), React.createElement("path", {
  className: "st2",
  d: "M533.7,855c-7.6,0.8-15.2,1.6-22.8,2C518.5,856.6,526.1,855.8,533.7,855z"
}), React.createElement("path", {
  className: "st2",
  d: "M534.9,854.8c11-1.4,22-3.2,32.4-5.4l0,0C556.9,851.6,546.1,853.4,534.9,854.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M351.1,842L351.1,842c45.6,13,103.8,18.8,159.4,15C454.1,860.8,395.3,854.4,351.1,842z"
}), React.createElement("path", {
  className: "st1",
  d: "M373.9,860.2c-0.8-0.2-1.6-0.4-2.4-0.6C372.3,859.8,373.1,860,373.9,860.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M343.3,852.6c1.2,0.4,2.8,0.6,4,1c-1.6-0.4-3-1-4.6-1.4C342.9,852.2,342.9,852.6,343.3,852.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M407.5,865.8c-0.6,0-1-0.2-1.6-0.2C406.5,865.8,406.9,865.8,407.5,865.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,446.8c-2-0.8-4.2-1.4-6.2-2"
}), React.createElement("path", {
  className: "st1",
  d: "M338.9,838.2c2,0.6,4,1.2,6.2,2"
}), React.createElement("path", {
  className: "st1",
  d: "M664.5,822.4c-1.2,0.8-2.4,1.8-3.6,2.6C662.1,824.2,663.3,823.2,664.5,822.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M587.7,857.4c1-0.2,2.2-0.6,3.2-0.8C589.7,856.8,588.7,857,587.7,857.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M573.5,860.6c-1.4,0-2.6-0.4-3.6-1.4c-1.2-1-1.8-2.2-2-3.6c-0.8,0.2-1.4,0.2-2.2,0.4c-2.6,0.6-5.2,1-7.8,1.6 c-6.6,1.2-13.2,2.2-20,3c-2.4,0.4-4.8,0.6-7.2,0.8c-5.4,0.6-10.8,1.2-16.2,1.6c-3.2,0.2-6.4,0.4-9.6,0.6c-4.2,0.2-8.6,0.4-12.8,0.6 c-3.4,0-7,0.2-10.4,0.2c-4,0-8.2,0-12.2,0c-3.4,0-7-0.2-10.4-0.2c-4.2-0.2-8.4-0.4-12.6-0.6c-3.2-0.2-6.4-0.4-9.6-0.6 c-6.4-0.4-12.8-1.2-19.2-1.8c-3.2-0.4-6.2-0.8-9.2-1.2c-4.4-0.6-9-1.2-13.2-1.8c-3-0.4-6-1-8.8-1.6c-3.8-0.6-7.6-1.4-11.4-2.2 c-2.8-0.6-5.6-1.2-8.4-1.8c-3.8-0.8-7.4-1.8-11-2.8c-2.4-0.6-5-1.2-7.4-2c-1-0.2-2-0.6-2.8-0.8v-0.2c-2-0.6-4.2-1.2-6.2-2v2 c0,2.6,1.6,4.6,3.8,5.6c1.6,0.4,3,1,4.6,1.4c7.8,2.2,15.8,4.2,24.4,6.2c0.8,0.2,1.6,0.4,2.4,0.6c10.2,2.2,21,4,32,5.4 c0.6,0,1,0.2,1.6,0.2c22.4,3,46,4.6,69.6,4.6C510.1,870.4,543.1,867.2,573.5,860.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M625.9,844.2c1.2-0.6,2.4-1,3.6-1.6C628.3,843.2,627.1,843.8,625.9,844.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M713.5,721.4c0.6,5.8,0.6,11.8,0,17.6l0,0c-2.6,23.6-15.8,47-39.2,67.6v5.2c0,1.6-0.8,3-1.8,4.2 c27.6-22.2,44.2-48.6,47.2-76.4c0.6-6.2,0.6-12.4,0-18.8V595.2l-6.2,3.6V721.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M713.5,523.6l0.8-0.4l5.4-6.6V328c-0.6,9.4-2.6,18.6-6.2,27.8V523.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M607.1,851.4c1.2-0.4,2.6-0.8,4-1.2C609.7,850.6,608.3,851,607.1,851.4z"
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,557.4 719.7,553.6 719.7,534.4 713.5,539.01  "
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,523.6 713.5,531.8 715.3,530.2 718.3,527.8 719.7,526.4 719.7,516.4 714.3,523.01  "
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,557.4 713.5,558.2 719.7,554.6 719.7,553.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "715.3,530.2 713.5,531.8 713.5,539.01 719.7,534.4 719.7,526.4 718.3,527.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,572.4 713.5,584.6 719.7,581 719.7,568.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,591.8 713.5,598.8 719.7,595.2 719.7,588.2  "
}), React.createElement("polygon", {
  className: "st1",
  points: "712.9,563.4 720.1,563.4 720.1,563.4  "
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,565.2 719.7,561.8 719.7,554.6 713.5,558.2  "
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,584.6 713.5,591.8 719.7,588.2 719.7,581  "
}), React.createElement("polygon", {
  className: "st1",
  points: "712.9,570.6 720.1,570.6 720.1,570.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,572.4 719.7,568.8 719.7,561.8 713.5,565.4  "
}), React.createElement("path", {
  className: "st1",
  d: "M514.3,863.01c-3.2,0.2-6.4,0.4-9.6,0.6C507.9,863.4,511.1,863.2,514.3,863.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M565.5,856.21c-2.6,0.6-5.2,1-7.8,1.6C560.5,857.2,562.9,856.6,565.5,856.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M537.9,860.6c-2.4,0.4-4.8,0.6-7.2,0.8C533.1,861.21,535.5,861,537.9,860.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M394.9,857.8c-3-0.4-6-1-8.8-1.6C388.9,856.8,391.7,857.2,394.9,857.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M491.7,864.01c-3.4,0-7,0.2-10.4,0.2C484.9,864.2,488.3,864.2,491.7,864.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M469.1,864.2c-3.4,0-7-0.2-10.4-0.2C462.1,864.01,465.7,864.01,469.1,864.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M417.3,860.8c-3.2-0.4-6.2-0.8-9.2-1.2C411.1,860,414.1,860.4,417.3,860.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M446.1,863.2c-3.2-0.2-6.4-0.4-9.6-0.6C439.7,863.01,442.9,863.01,446.1,863.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M355.1,849.4c-2.4-0.6-5-1.2-7.4-2C350.1,848.2,352.7,848.8,355.1,849.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M374.5,854.01c-2.8-0.6-5.6-1.2-8.4-1.8C368.9,852.8,371.7,853.4,374.5,854.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M338.9,838.2v6.4c2,0.6,4,1.2,6.2,2v-6.4C342.9,839.4,340.7,838.8,338.9,838.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.1,449c-2-0.6-4.2-1.4-6.2-2.2"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,840c2,0.6,4,1.4,6.2,2"
}), React.createElement("path", {
  className: "st1",
  d: "M510.9,857L510.9,857C510.7,857,510.7,857,510.9,857z"
}), React.createElement("path", {
  className: "st1",
  d: "M534.9,854.8c-0.4,0-0.8,0-1.4,0.2C534.1,855,534.5,854.8,534.9,854.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M565.5,856.21c0.8-0.2,1.4-0.2,2.2-0.4l0,0C566.9,855.8,566.3,856,565.5,856.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,846.6c1,0.2,2,0.6,2.8,0.8C346.9,847.2,345.9,846.8,344.9,846.6L344.9,846.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M366.1,852.2c-3.8-0.8-7.4-1.8-11-2.8C358.7,850.4,362.3,851.21,366.1,852.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M385.9,856.21c-3.8-0.6-7.6-1.4-11.4-2.2C378.3,854.8,382.1,855.4,385.9,856.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M530.5,861.4c-5.4,0.6-10.8,1.2-16.2,1.6C519.7,862.6,525.1,862,530.5,861.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M557.9,857.6c-6.6,1.2-13.2,2.2-20,3C544.5,859.8,551.3,858.8,557.9,857.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M408.1,859.6c-4.4-0.6-9-1.2-13.2-1.8C399.1,858.4,403.7,859.01,408.1,859.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M504.7,863.6c-4.2,0.2-8.6,0.4-12.8,0.6C496.1,864.01,500.3,863.8,504.7,863.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M481.3,864.2c-4,0-8.2,0-12.2,0C473.1,864.2,477.3,864.2,481.3,864.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M436.5,862.6c-6.4-0.4-12.8-1.2-19.2-1.8C423.5,861.6,429.9,862.2,436.5,862.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M458.7,864.01c-4.2-0.2-8.4-0.4-12.6-0.6C450.3,863.6,454.5,863.8,458.7,864.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M707.3,721.4c0,0.2,0,0.4,0,0.6c0.6,5.4,0.6,11,0,16.4c-2.4,21.2-14,41.8-33.2,59.8v8.4 c23.4-20.6,36.6-44,39.2-67.6l0,0c0.6-5.8,0.6-11.8,0-17.6V598.8l-6.2,3.6v119C707.1,721.4,707.3,721.4,707.3,721.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M567.5,854.6v-5c-10.6,2.2-21.4,4-32.4,5.4c-0.4,0-0.8,0-1.4,0.2c-7.6,0.8-15.2,1.6-22.8,2h-0.2 c-55.6,3.8-113.8-2.2-159.4-15l0,0c-2.2-0.6-4.2-1.2-6.2-2v6.4c1,0.2,1.8,0.6,2.8,0.8c2.4,0.6,4.8,1.4,7.4,2c3.6,1,7.2,1.8,11,2.8 c2.8,0.6,5.6,1.2,8.4,1.8c3.8,0.8,7.6,1.4,11.4,2.2c3,0.6,5.8,1,8.8,1.6c4.4,0.6,8.8,1.2,13.2,1.8c3,0.4,6.2,0.8,9.2,1.2 c6.2,0.8,12.6,1.4,19.2,1.8c3.2,0.2,6.4,0.4,9.6,0.6c4.2,0.2,8.4,0.4,12.6,0.6c3.4,0.2,7,0.2,10.4,0.2c4,0,8.2,0,12.2,0 c3.4,0,7,0,10.4-0.2c4.2-0.2,8.6-0.4,12.8-0.6c3.2-0.2,6.4-0.4,9.6-0.6c5.4-0.4,10.8-1,16.2-1.6c2.4-0.2,4.8-0.4,7.2-0.8 c6.8-0.8,13.4-1.8,20-3c2.6-0.4,5.2-1,7.8-1.6c0.8-0.2,1.4-0.4,2.2-0.4C567.7,855.2,567.5,855,567.5,854.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M713.5,355.4c-1.8,4.4-3.8,8.6-6.2,13v158.8l6.2-3.6V355.4z"
}), React.createElement("polygon", {
  className: "st1",
  points: "712.5,539.6 707.3,542.6 707.3,561 713.5,557.4 713.5,539.01  "
}), React.createElement("polygon", {
  className: "st1",
  points: "712.3,532.6 713.5,531.8 713.5,523.6 707.3,527.2 707.3,535.6 709.3,534.4  "
}), React.createElement("polygon", {
  className: "st1",
  points: "707.3,561.8 713.5,558.2 713.5,557.4 707.3,561  "
}), React.createElement("polygon", {
  className: "st1",
  points: "713.5,539.01 713.5,531.8 712.3,532.6 709.3,534.4 707.3,535.6 707.3,542.6 712.5,539.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "707.3,576 707.3,588.2 713.5,584.6 713.5,572.4  "
}), React.createElement("polygon", {
  className: "st1",
  points: "707.3,602.4 713.5,598.8 713.5,591.8 707.3,595.2  "
}), React.createElement("polygon", {
  className: "st1",
  points: "707.3,568.8 713.5,565.2 713.5,565.2  "
}), React.createElement("polygon", {
  className: "st1",
  points: "707.3,561.8 707.3,568.8 713.5,565.2 713.5,558.2  "
}), React.createElement("polygon", {
  className: "st1",
  points: "706.9,574.2 713.9,574.2 713.9,574.2  "
}), React.createElement("polygon", {
  className: "st1",
  points: "707.3,588.2 707.3,595.2 713.5,591.8 713.5,584.6  "
}), React.createElement("polygon", {
  className: "st1",
  points: "707.3,568.8 707.3,576 713.5,572.4 713.5,565.4  "
}), React.createElement("path", {
  className: "st1",
  d: "M713.5,316L713.5,316c3.4,0,6.2,2.8,6.2,6.2v5.6c0.2-1.8,0.4-3.8,0.4-5.6c0-24.6-10.2-48.4-29.4-69.4l-5.6,3.2 C702.5,274.8,711.9,295.2,713.5,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M231.1,316h0.6c2.6-33.6,25.8-66.8,70.2-92.4c89.4-51.6,231.6-54.2,326.4-7.8c0.6-0.8,1.2-1.4,2-2l3.8-2.2 c-96.6-48.4-243.4-46.4-335.4,6.6c-47.6,27.4-73.8,64.4-73.8,103.8C224.9,318.8,227.7,316,231.1,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M657.1,232.4c0.6-0.8,1.2-1.4,2-2l3.4-2c-5-3.4-10.2-6.8-15.6-10l-6.2,3.6c0.8,0.4,1.8,0.8,2.6,1.4 C648.1,226.4,652.7,229.4,657.1,232.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M628.3,215.8c2,1,3.8,2,5.8,3l6.4-3.6c-2.2-1.2-4.2-2.2-6.4-3.4l-3.8,2.2C629.5,214.4,628.9,215,628.3,215.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M646.9,218.6c-0.2-0.2-0.4-0.2-0.6-0.4c-2-1.2-4-2-6-3l-6.4,3.6c2.2,1.2,4.4,2.2,6.4,3.4L646.9,218.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M681.5,244c-2.6-2.4-5.6-5-8.4-7.2l-4.6,2.8v1.4c2.6,2,5.2,4.2,7.6,6.4L681.5,244z"
}), React.createElement("path", {
  className: "st1",
  d: "M690.7,252.8c-1.4-1.6-3-3-4.6-4.4l-5.6,3.2c1.6,1.4,3.2,3,4.6,4.4L690.7,252.8z"
}), React.createElement("polygon", {
  className: "st1",
  points: "659.1,230.6 662.5,228.6 662.5,228.6  "
}), React.createElement("path", {
  className: "st1",
  d: "M659.1,230.6c-0.8,0.4-1.4,1.2-2,2c1.8,1.2,3.4,2.4,5,3.6V236l5.6-3.2c-1.8-1.4-3.4-2.8-5.2-4L659.1,230.6z"
}), React.createElement("polygon", {
  className: "st1",
  points: "672.9,236.6 672.9,236.6 668.3,239.4  "
}), React.createElement("path", {
  className: "st1",
  d: "M680.5,251.6l5.6-3.2c-1.4-1.4-3-3-4.6-4.4l-5.6,3.2C677.5,248.6,678.9,250.2,680.5,251.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.1,236c2.2,1.6,4.2,3.2,6.2,4.8v-1.4l4.6-2.8c-1.8-1.4-3.4-2.8-5.2-4L662.1,236L662.1,236z"
}), React.createElement("path", {
  className: "st1",
  d: "M298.7,426c12.4,7.2,26,13.4,40,18.6V438c-13-5-25.4-10.8-37-17.4c-33.4-19.4-54.8-42.8-64.6-67.6v14.8 C249.5,389.6,270.1,409.6,298.7,426z"
}), React.createElement("path", {
  className: "st1",
  d: "M231.1,322.2L231.1,322.2c0-2,0.4-4.2,0.6-6.2h-0.6c-3.4,0-6.2,2.8-6.2,6.2l0,0c0,11,2.2,21.6,6.2,32V322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M237.3,353c-4-10.2-6.2-20.6-6.2-30.8l0,0v32.2c1.8,4.6,3.8,9,6.2,13.6V353z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.1,442.4v6.4c37.6,12.4,79.4,18.6,121.4,18.6c32.4,0,64.6-3.8,95-11v-6.2 C497.9,467.4,417.3,464.8,351.1,442.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M707.3,368.4V354c-6.6,16.2-18,31.8-34.6,46c1,1,1.6,2.4,1.6,3.8v2.8C688.5,395,699.7,382,707.3,368.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M338.9,438.2v6.6c2,0.8,4,1.4,6.2,2v-6.4C342.9,439.6,340.9,439,338.9,438.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M713.5,328.4v27.2c3.6-9,5.6-18.2,6.2-27.8v-5.6c0-3.4-2.8-6.2-6.2-6.2l0,0 C713.7,320.2,713.7,324.2,713.5,328.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,440.4v6.4c2,0.8,4.2,1.4,6.2,2.2v-6.4C349.1,441.8,346.9,441.2,344.9,440.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M713.5,328.4c-0.6,8.6-2.8,17.2-6.2,25.6v14.4c2.4-4.2,4.4-8.6,6.2-13V328.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M304.9,229L304.9,229c46.2-26.6,107-40,167.6-40c55.2,0,110.2,11.2,154.6,33.2v-3c0-1.2,0.4-2.4,1.2-3.4 c-94.8-46.4-237-43.8-326.4,7.8c-44.4,25.6-67.6,58.8-70.2,92.4h6.2C240.5,283.4,263.9,252.6,304.9,229z"
}), React.createElement("path", {
  className: "st1",
  d: "M707.3,316h6.2c-1.6-20.6-11-41.2-28.4-59.8l-5.4,3.2C696.3,276.6,705.7,296,707.3,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M655.9,239v-3.2c0-1.2,0.4-2.4,1.2-3.4c-4.4-3-9-6-13.8-8.8c-0.8-0.4-1.8-1-2.6-1.4l-1,0.6v5.8 c0.2,0.2,0.4,0.2,0.6,0.4C645.7,232.2,651.1,235.6,655.9,239z"
}), React.createElement("path", {
  className: "st1",
  d: "M627.1,222.2c2,1,4.2,2.2,6.2,3.2v-6l0.8-0.4c-2-1-3.8-2-5.8-3c-0.8,1-1.2,2.2-1.2,3.4V222.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M633.3,225.4c2,1,4.2,2,6.2,3.2v-5.8l1-0.6c-2.2-1.2-4.4-2.2-6.4-3.4l-0.8,0.4V225.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M670.3,250.4l5.6-3.2c-2.4-2.2-5-4.2-7.6-6.4v7.8C669.1,249.2,669.7,249.8,670.3,250.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M679.7,259.2l5.4-3.2c-1.4-1.6-3-3-4.6-4.4l-5.4,3.2C676.5,256.2,678.1,257.8,679.7,259.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M655.9,235.8v3.2c2.2,1.6,4,3.2,6.2,4.8V236c-1.6-1.2-3.2-2.4-5-3.6C656.5,233.4,655.9,234.6,655.9,235.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M680.5,251.6c-1.6-1.4-3-3-4.6-4.4l-5.6,3.2c1.6,1.4,3,3,4.6,4.4L680.5,251.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M668.3,248.6v-7.8c-2-1.6-4-3.2-6.2-4.8v7.8C664.1,245.4,666.3,246.8,668.3,248.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M301.9,420.8c11.6,6.6,24,12.4,37,17.4v-6.6c-12-4.8-23.4-10-34-16.2c-41-23.6-64.4-54.4-67-87h-0.6v24.8 C247.1,377.8,268.3,401.4,301.9,420.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M237.7,316h-6.2c-0.2,2-0.6,4.2-0.6,6.2h6.2C237.3,320,237.7,318,237.7,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M237.3,328.4h0.6c-0.2-2-0.6-4-0.6-6.2l0,0h-6.2c0,10.4,2.2,20.8,6.2,30.8V328.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M611.3,429.4c-1.8,0.8-3.4,1.4-5.2,2.2C607.9,430.8,609.5,430.2,611.3,429.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M572.1,442.8c1-0.2,1.8-0.6,2.6-0.8c-71,19.6-155.4,17.6-223.6-6v6.4c66.2,22.4,146.8,25,216.4,7.8v-1.4 C567.5,446,569.3,443.6,572.1,442.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M707.3,354v-25.8l0,0c-2.2,27.4-19,53.2-48.6,74.8c1.8-1.4,3.8-2.6,5.6-4c1.8-1.4,4.4-1.8,6.4-0.8 c0.8,0.4,1.4,1,2,1.8C689.3,385.8,700.7,370.2,707.3,354z"
}), React.createElement("path", {
  className: "st1",
  d: "M654.3,406.4c-4.4,3-9.2,6.2-14.2,9C645.1,412.6,649.9,409.4,654.3,406.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,433.8c-2-0.8-4-1.6-6.2-2.4v6.6c2,0.8,4,1.4,6.2,2.2V433.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M713.5,322.2v6.2c0.4-4.2,0.4-8.2,0-12.4h-6.2c0.2,2,0.6,4.2,0.6,6.2C707.9,322.2,713.5,322.2,713.5,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,433.8v6.4c2,0.8,4.2,1.4,6.2,2.2v-6.4C349.1,435.2,346.9,434.6,344.9,433.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M713.5,322.2h-5.6l0,0c0,2-0.4,4-0.6,6.2l0,0v25.8c3.4-8.4,5.4-17,6.2-25.6 C713.5,328.6,713.5,322.2,713.5,322.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M319.1,289.2c84.6-48.8,222.2-48.8,306.8,0c13.8,8,25.6,17,35.4,26.8h17.2c-1.8-19.6-12.2-38.2-30.4-54.8 L630.3,251c-1.8-1.2-3-3.2-3-5.2v-0.2c-2.4-1.6-4.8-3.2-7.4-4.6c-81.2-46.8-213.2-46.8-294.4,0c-35.6,20.6-56,47.2-58.8,75.2h17.2 C293.5,306.2,305.3,297.2,319.1,289.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M630.3,251l17.8,10.2c-6.2-5.6-13-10.8-20.8-15.8v0.2C627.1,247.8,628.3,249.8,630.3,251z"
}), React.createElement("path", {
  className: "st2",
  d: "M266.7,328.4c0.2,2.6,0.6,5.4,1.2,8c1.6-2.8,3.6-5.4,5.6-8H266.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M283.9,316h-17.2c-0.2,2-0.6,4.2-0.6,6.2h12.4C280.3,320,281.9,318,283.9,316z"
}), React.createElement("path", {
  className: "st2",
  d: "M278.5,322.2h-12.4l0,0c0,2,0.4,4,0.6,6.2h6.8C274.9,326.2,276.7,324.2,278.5,322.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M677.3,336.2c0.6-2.6,1-5.2,1.2-8h-6.8C673.7,331,675.7,333.6,677.3,336.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M666.7,322.2h12.4c0-2-0.4-4.2-0.6-6.2h-17.2C663.3,318,664.9,320,666.7,322.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M678.5,328.4c0.2-2,0.6-4,0.6-6.2l0,0h-12.4c1.8,2,3.6,4,5,6.2H678.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M322.3,235.4c83-48,217.6-48,300.6,0c1.6,0.8,2.8,1.8,4.4,2.8V231c-0.4-0.2-0.8-0.6-1.2-0.8 c-84.6-48.8-222.2-48.8-306.8,0c-39.6,23-62.2,53.2-64.8,86h6.2C263.1,286.6,283.5,257.8,322.3,235.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M690.7,316c-1.4-17.8-8.8-35-21.8-50.6l-3.8,2.2c-0.6,0.4-1.4,0.4-2,0.6c12.8,15.2,20,31.4,21.4,47.8H690.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M655.5,251.2c-4.8-4.4-10.2-8.6-16-12.6v3.4L655.5,251.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M633.3,242v-7.2c-2-1.4-4-2.6-6.2-4v7.2C629.3,239.4,631.3,240.8,633.3,242z"
}), React.createElement("path", {
  className: "st1",
  d: "M655.9,258.6l-4.2-2.4c1.4,1.4,2.8,2.8,4.2,4.2V258.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M651.7,256.2l4.2,2.4v-7c-0.2-0.2-0.4-0.4-0.6-0.4l-16-9.2v-3.4c-2-1.4-4.2-2.6-6.2-4v7.2 C640.1,246.6,646.3,251.4,651.7,256.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M667.9,264c-0.4,1.4-1.2,2.8-2.6,3.6l3.8-2.2C668.5,265,668.3,264.4,667.9,264z"
}), React.createElement("path", {
  className: "st1",
  d: "M663.3,268c0.6-0.2,1.4-0.2,2-0.6c1.4-0.8,2.2-2.2,2.6-3.6c-1-1.2-1.8-2.4-2.8-3.4l-3,1.6l-6.2-3.6v1.6 C658.5,263,660.9,265.4,663.3,268z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.1,257.8c-2-2-4-4-6.2-6v7l6.2,3.6V257.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M665.1,260.6c-0.8-1-2-1.8-3-2.8v4.6L665.1,260.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M282.1,385.8c-4.6-4.8-8.8-9.8-12.2-14.8C273.3,376.2,277.5,381,282.1,385.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M263.5,344c-1.6-5.2-2.6-10.4-3-15.8h-6.2c0.6,8.6,2.8,17.2,6.2,25.4c-0.6-1.4-0.6-3,0-4.4 C261.3,347.6,262.5,345.8,263.5,344z"
}), React.createElement("path", {
  className: "st1",
  d: "M319.1,414.2c6.2,3.6,13,6.8,19.8,10l0,0C332.1,421.2,325.3,417.8,319.1,414.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M319.1,414.2c-6.6-3.8-12.4-7.8-18-12C306.7,406.4,312.5,410.4,319.1,414.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M297.1,399.2c-4.6-3.6-8.8-7.4-12.8-11.2C288.3,392,292.5,395.6,297.1,399.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.5,370.6c-3.2-4.8-6-9.8-8.2-14.8C263.5,360.6,266.3,365.6,269.5,370.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M260.5,316h-6.2c-0.2,2-0.6,4.2-0.6,6.2h6.2C259.9,320,260.3,318,260.5,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M259.9,322.2h-6.2l0,0c0,2,0.4,4,0.6,6.2h6.2C260.3,326.2,259.9,324.2,259.9,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M681.7,344c0.8,1.8,2.2,3.4,3,5.2c0.6,1.4,0.6,3,0,4.4c3.4-8.2,5.6-16.8,6.2-25.4h-6.2 C684.1,333.6,683.3,338.8,681.7,344z"
}), React.createElement("path", {
  className: "st1",
  d: "M478.7,450.8c53.4-0.8,106.4-13,147.2-36.6C585.3,437.8,532.3,449.8,478.7,450.8L478.7,450.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M683.7,355.6c-2.2,5-5,10-8.2,14.8C678.9,365.6,681.5,360.6,683.7,355.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M472.5,451c1.4,0,2.6,0,3.8-0.2l0,0C475.1,450.8,473.9,451,472.5,451z"
}), React.createElement("path", {
  className: "st1",
  d: "M643.9,402.4c-5.6,4.2-11.4,8.2-17.8,11.8C632.5,410.6,638.3,406.6,643.9,402.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M675.1,371c-3.4,5-7.6,10-12.2,14.8C667.5,381,671.7,376,675.1,371z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.1,429.4L351.1,429.4c36.6,14.2,79,21.4,121.4,21.4C430.1,451,387.7,443.8,351.1,429.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M660.3,388.4c-3.8,3.8-7.8,7.2-12.2,10.8C652.5,395.6,656.7,392,660.3,388.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,426.8c-2-0.8-4.2-1.6-6.2-2.6l0,0C340.9,425.2,342.9,426,344.9,426.8L344.9,426.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M685.1,322.2h6.2c0-2-0.4-4.2-0.6-6.2h-6.2C684.7,318,685.1,320,685.1,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.1,429.4c-2.2-0.8-4.2-1.8-6.2-2.6l0,0C346.9,427.8,349.1,428.6,351.1,429.4L351.1,429.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M691.3,322.2h-6.2c0,2-0.4,4.2-0.6,6.2h6.2C690.9,326.2,691.3,324.2,691.3,322.2L691.3,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.3,240.6c81.2-46.8,213.2-46.8,294.4,0c2.6,1.6,5,3.2,7.4,4.6V238c-1.4-1-2.8-1.8-4.4-2.8 c-83.2-48-217.6-48-300.6,0c-38.8,22.4-59.2,51.2-61.8,80.6h6.2C269.3,287.8,289.7,261.2,325.3,240.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M678.5,316h6.2c-1.6-16.4-8.6-32.8-21.4-48c-1.4,0.2-2.8,0.2-4.2-0.6l-11-6.4 C666.1,277.8,676.5,296.4,678.5,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M648.1,261.2l11,6.4c-2-1.2-3-3.2-3-5.4v-1.8c-1.4-1.4-2.8-2.8-4.2-4.2l-18.4-10.6V242c-2-1.4-4-2.6-6.2-4v7.2 C634.9,250.4,641.9,255.6,648.1,261.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M651.7,256.2c-5.4-5-11.6-9.6-18.4-14.2v3.6L651.7,256.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M663.3,268c-2.2-2.6-4.6-5.2-7.2-7.8v1.8c0,2.2,1.2,4.2,3,5.4C660.3,268.4,661.9,268.4,663.3,268z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.7,328.4h-6.2c0.4,5.2,1.4,10.6,3,15.8c1.4-2.6,2.8-5.2,4.4-7.8C267.3,333.6,266.9,331,266.7,328.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.7,316h-6.2c-0.2,2-0.6,4.2-0.6,6.2h6.2C266.1,320,266.5,318,266.7,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.1,322.2L266.1,322.2h-6.2c0,2,0.4,4.2,0.6,6.2h6.2C266.5,326.2,266.1,324.2,266.1,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M677.3,336.2c1.6,2.6,3,5.2,4.4,7.8c1.6-5.2,2.6-10.4,3-15.8h-6.2C678.3,331,677.9,333.6,677.3,336.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M685.1,322.2c0-2-0.4-4.2-0.6-6.2h-6.2c0.2,2,0.6,4.2,0.6,6.2H685.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M678.9,322.2c0,2-0.4,4-0.6,6.2h6.2c0.2-2,0.6-4.2,0.6-6.2H678.9L678.9,322.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M426.7,306.6c-14.4,2-28.2,5.2-40.4,9.2h164.2c-3.6-1.2-7.2-2.4-11.2-3.4C506.1,303.2,466.1,301.2,426.7,306.6 z"
}), React.createElement("path", {
  className: "st0",
  d: "M425.1,294.4c41-5.6,82.8-3.4,117.6,6.2c14.8,4,27.2,9.2,37.6,15.4h62.4c-6.8-5.6-14.2-11.2-22.8-16.2 c-81.2-46.8-213.2-46.8-294.4,0c-8.6,5-16,10.4-23,16.2h42.4h10.8c4-2.2,8.2-4.4,12.6-6.4C384.7,302.6,403.7,297.4,425.1,294.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M335.7,357.6c0.2,1.2,0.6,2.6,1.2,3.8c0.4,1,1.4,2,2,2.8v-18C336.7,349.6,335.1,353.6,335.7,357.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M338.9,381.4c-5.8-4-10.8-9-13.4-15c-1-2.4-1.6-4.8-2-7c-1.2-8.6,2.2-17.6,9.6-26.2c1.4-1.6,3.2-3.2,5-4.8 h-48.8c-6.8,7.4-12.4,15.2-16.4,23.2c0.2,0.4,0.2,0.6,0.4,1c4.4,9,10.8,17.8,18.8,26c0.8,0.8,1.6,1.6,2.4,2.2c3.4,3.2,7,6.4,11,9.4 c1.2,1,2.4,1.8,3.6,2.8c5,3.6,10.2,7.2,16,10.6c4.4,2.6,9,4.8,13.6,7v-29.2H338.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M344.9,316h-42.4c-2.4,2-5,4-7.2,6.2h43.6C338.9,318.8,341.5,316,344.9,316z"
}), React.createElement("path", {
  className: "st0",
  d: "M338.9,322.2h-43.6c-2.2,2-4,4-5.8,6.2h48.8c0.2-0.2,0.4-0.4,0.8-0.6v-5.6 C339.1,322.2,338.9,322.2,338.9,322.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M635.9,393c1.2-0.8,2.2-1.8,3.4-2.6c4-3.2,7.8-6.4,11.2-9.6c0.8-0.8,1.6-1.4,2.2-2.2c8.2-8.2,14.4-17,18.8-26 c0.2-0.4,0.2-0.6,0.4-1c-3.8-8.2-9.6-15.8-16.4-23.2h-58.8c5,5,9,10.2,11.4,15.8c1.2,2.8,2.2,5.8,2.6,8.8 c2.6,13.6-2.2,27.8-13.6,41.2c-11.8,13.6-30.4,26.2-54,36.4c-2,1-4,1.4-6.2,2.4c30.2-5.6,58.6-15.4,82.6-29.2 C625.5,400.4,630.9,396.8,635.9,393z"
}), React.createElement("path", {
  className: "st0",
  d: "M538.5,419.2c21.8-9.4,39-21,49.6-33.2c6.2-7.2,13.4-18.4,11-30.6c-0.4-2.2-1.2-4.2-2-6.2 c-3.2-7.4-10-14.4-19.8-20.6H358.9c-2.8,1.6-5.4,3.4-7.8,5.2v40.6c5.4,3,11.8,5.6,19.6,7.6c21,5.8,47.4,7,72.6,3.6 c12.2-1.6,23-4.6,32.2-8.4c8-3.4,14-7.6,17.8-11.8c1.6-2,3.6-4.8,2.8-6.8c-0.8-2.6-6-6.8-17.6-10c-3.4-0.8-5.2-4.2-4.4-7.4 c0.8-3.4,4.2-5.2,7.6-4.4c10.2,2.6,23,8,26.2,18.2c1.4,4.2,1.4,10.8-5.2,18.6c-5,5.8-12.4,10.8-22.2,15c-10.2,4.4-22,7.6-35.4,9.4 c-26.6,3.8-54.8,2.2-77.4-3.8c-5.2-1.4-10.8-3.4-16.4-5.8v28c36.2,15,78.8,22.6,121.4,22.6c1.2,0,2.6,0,3.8-0.2 C497.1,434.6,517.5,428.2,538.5,419.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M338.9,381.4v29.4c2,1,4,1.8,6.2,2.8v-28.4C342.9,384,340.7,382.6,338.9,381.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M342.3,341.4c-1.2,1.4-2.4,3-3.6,4.8v18c1.4,2,3.6,4,6.2,6v-31.4C344.1,339.6,343.1,340.6,342.3,341.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M386.5,316c-4.6,1.6-9.2,3.2-13.4,5c-0.8,0.4-1.6,0.8-2.4,1.2h195c-4.6-2.2-9.6-4.4-15-6.2H386.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M642.7,316h-62.4c3.4,2,6.4,4,9.4,6.2h60.2C647.7,320,645.1,318,642.7,316z"
}), React.createElement("path", {
  className: "st0",
  d: "M345.9,322.2c3-2.2,6.2-4.2,9.8-6.2h-10.8c-3.4,0-6.2,2.8-6.2,6.2h6.2H345.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M344.9,322.2h-6.2v5.4c1.8-1.6,4-3.2,6.2-4.8V322.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M344.9,385v28.4c2,1,4.2,1.8,6.2,2.6v-28C349.1,387.2,346.9,386.2,344.9,385z"
}), React.createElement("path", {
  className: "st0",
  d: "M344.9,370.4c1.8,1.4,3.8,2.6,6.2,4v-40.6c-2.2,1.8-4.4,3.6-6.2,5.4V370.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M344.9,322.8c0.4-0.2,0.6-0.4,1-0.6h-1V322.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M649.9,322.2h-60.2c2.6,2,5,4,7.2,6.2h58.8C653.9,326.2,651.9,324.2,649.9,322.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M370.7,322.2c-4.2,2-8.2,4-11.8,6.2h218.2c-3.4-2.2-7.4-4.2-11.4-6.2H370.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M272.9,351.8c0.2,0.4,0.4,0.6,0.6,1C273.3,352.4,273.1,352,272.9,351.8C273.1,351.6,272.9,351.8,272.9,351.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M309.3,393.2c-1.2-0.8-2.4-1.8-3.6-2.8C306.9,391.2,308.1,392.2,309.3,393.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M294.7,381c-0.8-0.8-1.6-1.6-2.4-2.2C293.1,379.4,293.9,380.2,294.7,381z"
}), React.createElement("path", {
  className: "st0",
  d: "M652.7,378.8c-0.8,0.8-1.4,1.4-2.2,2.2C651.3,380.2,651.9,379.4,652.7,378.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M472.5,438.8c1.2,0,2.6,0,3.8-0.2l0,0C475.1,438.6,473.9,438.8,472.5,438.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M537.1,432.8L537.1,432.8c30.2-5.6,58.6-15.2,82.6-29.2C595.9,417.4,567.3,427.2,537.1,432.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M639.3,390.4c-1.2,0.8-2.2,1.8-3.4,2.6C637.1,392.2,638.1,391.4,639.3,390.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M672.1,351.8C672.1,351.8,672.1,351.6,672.1,351.8c-0.2,0.2-0.4,0.6-0.6,0.8 C671.7,352.4,671.9,352,672.1,351.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M260.5,354.2c0.2,0.4,0.6,1,0.8,1.4c-0.2-0.6-0.6-1.2-0.8-1.8C260.5,353.8,260.5,354,260.5,354.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M284.5,388c-0.8-0.8-1.6-1.4-2.4-2.2C282.9,386.6,283.7,387.4,284.5,388z"
}), React.createElement("path", {
  className: "st1",
  d: "M301.1,402.2c-1.4-1-2.6-2-3.8-3C298.5,400.2,299.7,401.4,301.1,402.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.9,371c-0.2-0.2-0.2-0.4-0.2-0.4C269.7,370.6,269.7,370.8,269.9,371z"
}), React.createElement("path", {
  className: "st1",
  d: "M648.1,399c-1.4,1.2-2.8,2.2-4.2,3.4C645.3,401.4,646.7,400.2,648.1,399z"
}), React.createElement("path", {
  className: "st1",
  d: "M675.5,370.4c-0.2,0.2-0.2,0.4-0.4,0.6C675.3,370.8,675.5,370.6,675.5,370.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M663.1,385.8c-0.8,0.8-1.8,1.6-2.6,2.6C661.3,387.4,662.1,386.6,663.1,385.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M684.5,354.2c0-0.2,0-0.2,0-0.4c-0.2,0.6-0.6,1.2-0.8,1.8C683.9,355.2,684.3,354.6,684.5,354.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M322.3,294.4c83-48,217.6-48,300.6,0c11.4,6.6,20.8,13.8,29.2,21.4h9.2c-9.6-9.8-21.6-18.8-35.4-26.8 c-84.6-48.8-222.2-48.8-306.8,0c-13.8,8-25.6,17-35.4,26.8h9.2C301.3,308.4,310.9,301,322.3,294.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M273.3,328.4c-2,2.6-3.8,5.2-5.6,8c0.6,2.8,1.2,5.8,2.2,8.6c3-5.6,6.8-11.2,11.2-16.4h-7.8V328.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M293.1,316h-9.2c-2,2-3.6,4.2-5.4,6.2h7.8C288.3,320,290.9,318,293.1,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M278.5,322.2c-1.8,2-3.6,4-5,6.2h8c1.8-2,3.2-4.2,5-6.2H278.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M663.9,328.4c4.4,5.4,8.2,10.8,11.2,16.4c1-2.8,1.6-5.6,2.2-8.6c-1.6-2.6-3.6-5.4-5.6-8h-7.8 C663.9,328.2,663.9,328.4,663.9,328.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M658.7,322.2h8c-1.8-2-3.4-4.2-5.4-6.2h-9.2C654.3,318,656.7,320,658.7,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M671.7,328.4c-1.6-2-3.4-4.2-5-6.2h-8c2,2,3.4,4.2,5,6.2H671.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M338.9,417.6c-5.8-2.6-11.2-5.6-16.6-8.6c-6.4-3.6-12-7.6-17.4-11.6c-1.6-1.2-3-2.4-4.6-3.6 c-3.8-3.2-7.4-6.2-10.8-9.6c-1.2-1.2-2.4-2.2-3.4-3.4c-4-4.4-7.8-8.8-10.8-13.2c-0.4-0.6-0.8-1.4-1.2-2c-2.6-3.8-4.8-7.8-6.6-11.8 c-0.4-0.6-0.8-1.2-1-2l0.2-0.2c-1-2.4-2-5-2.8-7.4c-1,1.8-2.2,3.4-3,5.2c-0.6,1.4-0.6,3,0,4.4c0.2,0.6,0.6,1.2,0.8,1.8 c2.2,5,5,10,8.2,14.8c0.2,0.2,0.2,0.4,0.2,0.4c3.6,5.2,7.6,10,12.2,14.8c0.8,0.8,1.6,1.4,2.4,2.2c3.8,3.8,8.2,7.6,12.8,11.2 c1.2,1,2.6,2,3.8,3c5.6,4.2,11.6,8.2,18,12c6.2,3.6,13,6.8,19.8,10v-6.4C339.1,417.6,338.9,417.6,338.9,417.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M476.5,450.8c-2.6-0.2-4.8-2-5.4-4.8c0-0.4,0.2-0.8,0.2-1.2c-42.2-0.2-84.2-7.6-120.2-22v6.6 c36.6,14.2,79,21.4,121.4,21.4C473.9,451,475.1,450.8,476.5,450.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M681.7,344c-0.8,2.4-1.8,5-2.8,7.4l0.2,0.2c-0.2,0.6-0.8,1.2-1,2c-1.8,3.8-3.8,7.8-6.4,11.6 c-0.6,0.8-1,1.8-1.6,2.6c-3,4.4-6.6,8.8-10.6,13c-1.2,1.2-2.6,2.6-4,3.8c-3.2,3-6.6,6.2-10.2,9c-1.6,1.2-3.2,2.6-5,3.8 c-5.4,4-11,7.8-17.4,11.4c-32,18.4-71.8,29.8-113.2,34c-10.2,3.2-20.6,5.8-30.8,7.8c53.4-0.8,106.4-13,147.2-36.6 c6.4-3.8,12.4-7.8,17.8-11.8c1.4-1,2.8-2.2,4.2-3.4c4.4-3.4,8.4-7,12.2-10.8c0.8-0.8,1.8-1.6,2.6-2.6c4.6-4.8,8.6-9.6,12.2-14.8 c0.2-0.2,0.2-0.4,0.4-0.6c3.2-4.8,6-9.8,8.2-14.8c0.2-0.6,0.6-1.2,0.8-1.8c0.6-1.4,0.6-3,0-4.4C683.7,347.6,682.5,345.8,681.7,344z "
}), React.createElement("path", {
  className: "st1",
  d: "M338.9,417.6v6.6c2,1,4,1.8,6.2,2.6v-6.6C342.9,419.2,340.7,418.4,338.9,417.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.1,422.8c-2-0.8-4.2-1.8-6.2-2.6v6.6c2,0.8,4,1.8,6.2,2.6V422.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M273.9,365.6c-2.6-3.8-4.8-7.8-6.6-11.8C269.1,357.8,271.3,361.6,273.9,365.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M285.9,381c-4-4.4-7.8-8.8-10.8-13.2C278.1,372.2,281.9,376.6,285.9,381z"
}), React.createElement("path", {
  className: "st1",
  d: "M300.3,393.8c-3.8-3.2-7.4-6.2-10.8-9.6C292.7,387.6,296.3,390.6,300.3,393.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M267.7,336.2c-1.6,2.6-3,5.2-4.4,7.8c0.8,2.4,1.8,5,2.8,7.4c1-2.2,2.4-4.4,3.8-6.6 C269.1,342,268.3,339.2,267.7,336.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M322.1,409c-6.4-3.6-12-7.6-17.4-11.6C310.1,401.4,315.9,405.2,322.1,409z"
}), React.createElement("path", {
  className: "st1",
  d: "M640.1,397.4c-5.4,4-11,7.8-17.4,11.4C629.1,405.2,634.9,401.4,640.1,397.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M677.9,353.6c-1.8,3.8-3.8,7.8-6.4,11.6C673.9,361.4,676.1,357.6,677.9,353.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M669.9,367.8c-3,4.4-6.6,8.8-10.6,13C663.3,376.6,666.9,372.2,669.9,367.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M675.1,344.8c1.2,2.2,2.8,4.4,3.6,6.6c1-2.4,2-5,2.8-7.4c-1.4-2.6-2.8-5.2-4.4-7.8 C676.7,339.2,676.1,342,675.1,344.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M655.3,384.6c-3.2,3-6.6,6.2-10.2,9C648.7,390.6,652.1,387.6,655.3,384.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.3,299.8c81.2-46.8,213.2-46.8,294.4,0c8.6,5,16,10.4,22.8,16.2h9.4c-8.2-7.6-17.8-14.8-29.2-21.4 c-83.2-48-217.6-48-300.6,0c-11.4,6.6-20.8,13.8-29.2,21.4h9.4C309.3,310.2,316.7,304.8,325.3,299.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.3,403.6c-5.8-3.4-11-6.8-16-10.6C314.3,396.8,319.5,400.2,325.3,403.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.3,403.6c4.4,2.6,9,4.8,13.6,7l0,0C334.1,408.4,329.5,406.2,325.3,403.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M305.7,390.4c-4-3-7.6-6.2-11-9.4C298.1,384.2,301.7,387.2,305.7,390.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M292.3,378.6c-8.2-8.2-14.4-17-18.8-26C277.9,361.8,284.1,370.4,292.3,378.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M281.3,328.4c-4.4,5.4-8.2,10.8-11.2,16.4c0.8,2.4,2,4.6,3,6.8c3.8-8.2,9.6-15.8,16.4-23.2H281.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M293.1,316c-2.2,2-4.8,4-6.8,6.2h8.8c2.2-2.2,4.8-4.2,7.2-6.2H293.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M295.3,322.2h-8.8c-2,2-3.4,4.2-5,6.2h8C291.3,326.2,293.1,324.2,295.3,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M650.5,380.8c-3.4,3.4-7.2,6.6-11.2,9.6C643.3,387.4,647.1,384.2,650.5,380.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.1,416.2c36.2,15,78.8,22.6,121.4,22.6C429.9,438.8,387.3,431.2,351.1,416.2L351.1,416.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M655.7,328.4c6.8,7.4,12.4,15.2,16.4,23.2c1-2.2,2.2-4.6,3-6.8c-3-5.6-6.8-11.2-11.2-16.4H655.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M671.5,352.6c-4.4,9-10.8,17.8-18.8,26C660.9,370.4,667.3,361.8,671.5,352.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M635.9,393c-5,3.6-10.2,7.2-16,10.6C625.7,400.2,630.9,396.8,635.9,393z"
}), React.createElement("path", {
  className: "st1",
  d: "M338.9,410.8L338.9,410.8c2,1,4,1.8,6.2,2.8l0,0C342.9,412.6,340.9,411.6,338.9,410.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M649.9,322.2h8.8c-2-2.2-4.6-4.2-6.8-6.2h-9.4C645.1,318,647.7,320,649.9,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.1,416.2c-2-0.8-4.2-1.8-6.2-2.6l0,0C346.9,414.4,349.1,415.2,351.1,416.2L351.1,416.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M655.7,328.4h8c-1.8-2-3.2-4.2-5-6.2h-8.8C651.9,324.2,653.9,326.2,655.7,328.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M275.1,367.6c-0.4-0.6-0.8-1.4-1.2-2C274.3,366.2,274.7,367,275.1,367.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.1,351.8c0.2,0.6,0.8,1.2,1,2c-0.4-0.8-0.6-1.4-1-2.2C266.3,351.6,266.3,351.6,266.1,351.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M289.5,384.2c-1.2-1.2-2.4-2.2-3.4-3.4C287.1,382,288.3,383.2,289.5,384.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M304.7,397.4c-1.6-1.2-3-2.4-4.6-3.6C301.7,395,303.1,396.2,304.7,397.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M671.5,365.2c-0.6,0.8-1,1.8-1.6,2.6C670.5,367,670.9,366,671.5,365.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M659.3,380.8c-1.2,1.2-2.6,2.6-4,3.8C656.7,383.2,658.1,382,659.3,380.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M645.1,393.6c-1.6,1.2-3.2,2.6-5,3.8C641.9,396.2,643.5,395,645.1,393.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M678.9,351.8l-0.2-0.2c-0.4,0.8-0.6,1.4-1,2.2C678.1,353,678.5,352.4,678.9,351.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.3,403.6c-5.8-3.4-11-6.8-16-10.6c-1.2-0.8-2.4-1.8-3.6-2.8c-4-3-7.6-6.2-11-9.4c-0.8-0.8-1.6-1.6-2.4-2.2 c-8.2-8.2-14.4-17-18.8-26c-0.2-0.4-0.4-0.6-0.6-1c0,0,0,0,0-0.2c-1-2.2-2.2-4.6-3-6.8c-1.2,2.2-2.8,4.4-3.8,6.6 c0.4,0.8,0.6,1.4,1,2.2c1.8,4,4,8,6.6,11.8c0.4,0.6,0.8,1.4,1.2,2c3.2,4.6,6.8,9,10.8,13.2c1,1.2,2.2,2.2,3.4,3.4 c3.4,3.2,7,6.4,10.8,9.6c1.6,1.2,3,2.4,4.6,3.6c5.4,4,11,7.8,17.4,11.6c5.4,3,10.8,6,16.6,8.6v-6.8 C334.1,408.4,329.5,406.2,325.3,403.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M475.9,438.8c0.2,0,0.4,0,0.6-0.2c-1.2,0-2.6,0.2-3.8,0.2c-42.6,0-85.2-7.6-121.4-22.6v6.6 c36,14.6,78,22,120.2,22C471.3,442,472.9,439.4,475.9,438.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M672.1,351.6C672.1,351.6,672.1,351.8,672.1,351.6c0,0.4-0.4,0.8-0.4,1c-4.4,9-10.8,17.8-18.8,26 c-0.8,0.8-1.4,1.4-2.2,2.2c-3.4,3.2-7.2,6.4-11.2,9.6c-1.2,0.8-2.2,1.8-3.4,2.6c-5,3.6-10.2,7.2-16,10.6 c-24,13.8-52.4,23.4-82.8,29.2c-9.2,3.8-18.4,7.4-27.4,10.2c41.4-4.2,81.2-15.6,113.2-34c6.4-3.6,12-7.4,17.4-11.4 c1.8-1.2,3.4-2.6,5-3.8c3.6-3,7-6,10.2-9c1.4-1.2,2.6-2.6,4-3.8c4-4.2,7.6-8.6,10.6-13c0.6-0.8,1-1.8,1.6-2.6 c2.4-3.8,4.6-7.6,6.4-11.6c0.4-0.8,0.6-1.4,1-2.2c-1-2.2-2.4-4.4-3.6-6.6C674.3,347.2,673.1,349.4,672.1,351.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,413.6c-2-1-4.2-1.8-6.2-2.8v6.8c2,1,4,1.8,6.2,2.6V413.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,413.6v6.6c2,0.8,4.2,1.8,6.2,2.6v-6.6C349.1,415.2,346.9,414.4,344.9,413.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M477.1,451c0.4,0,0.8,0,1.2-0.2c0.2,0,0.4,0,0.6-0.2c-0.8,0-1.6,0-2.4,0C476.7,450.8,476.9,451,477.1,451z"
}), React.createElement("path", {
  className: "st1",
  d: "M476.5,450.8L476.5,450.8c0.8,0,1.6,0,2.4,0l0,0C477.9,450.8,477.3,450.8,476.5,450.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M426.7,306.6c39.4-5.4,79.4-3.4,112.8,5.8c3.8,1,7.6,2.2,11.2,3.4h29.8c-10.4-6-22.8-11.2-37.6-15.4 c-34.8-9.6-76.6-11.8-117.6-6.2c-21.4,3-40.4,8-56.8,15.2c-4.6,2-8.6,4.2-12.6,6.4h30.8C398.7,311.8,412.3,308.8,426.7,306.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M336.7,361.4c-0.6-1.2-1-2.6-1.2-3.8c-0.6-4,1-8,3.2-11.4v-17.8h-0.8c-1.8,1.6-3.4,3.2-5,4.8 c-7.6,8.4-11,17.6-9.6,26.2c0.4,2.4,1,4.6,2,7c2.6,6,7.6,11,13.4,15v-17C338.1,363.4,337.1,362.4,336.7,361.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M338.9,327.6c-0.2,0.2-0.4,0.4-0.8,0.6h0.8V327.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.1,333.6c2.4-1.8,5-3.6,7.8-5.2h-7.8V333.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M597.3,394c11.6-13.4,16.2-27.6,13.6-41.2c-0.6-3-1.4-6-2.6-8.8c-2.4-5.6-6.4-10.8-11.4-15.8h-19.8 c9.8,6.2,16.6,13.2,19.8,20.6c0.8,2,1.4,4.2,2,6.2c2.4,12.2-4.6,23.4-11,30.6c-10.6,12.2-27.8,23.8-49.6,33.2 c-21,9.2-41.2,15.4-62,19.6c20.6-0.2,41-2.2,60.8-5.8c2-0.8,4-1.4,6.2-2.4C566.9,420.2,585.5,407.6,597.3,394z"
}), React.createElement("path", {
  className: "st1",
  d: "M367.5,393.8c22.6,6.2,51,7.6,77.4,3.8c13.4-1.8,25.2-5,35.4-9.4c9.8-4.2,17.2-9.2,22.2-15 c6.8-7.8,6.6-14.4,5.2-18.6c-3.2-10.2-16-15.4-26.2-18.2c-3.4-0.8-6.6,1.2-7.6,4.4c-0.8,3.4,1,6.6,4.4,7.4c11.6,3,16.6,7.2,17.6,10 c0.6,2-1.2,4.8-2.8,6.8c-3.8,4.2-9.8,8.4-17.8,11.8c-9,4-20,6.8-32.2,8.4c-25,3.4-51.4,2.2-72.6-3.6c-7.8-2-14.2-4.8-19.6-7.6v13.8 C356.7,390.4,362.3,392.4,367.5,393.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,370.4c-2.6-2-4.6-4-6.2-6v17c2,1.4,4,2.6,6.2,3.8V370.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,338.8v-10.6h-6.2V346c1.2-1.8,2.4-3.4,3.6-4.8C343.1,340.6,344.1,339.6,344.9,338.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M550.7,316c5.4,1.8,10.4,4,15,6.2h24c-2.8-2.2-6-4.2-9.4-6.2H550.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M386.5,316h-30.8c-3.6,2-6.8,4-9.8,6.2h24.8c0.8-0.4,1.6-0.8,2.4-1.2C377.3,319.2,381.7,317.6,386.5,316z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,322.8c-2.2,1.6-4.2,3.2-6.2,4.8v0.6h6.2V322.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,385c2,1,4,2,6.2,3v-13.8c-2.4-1.2-4.4-2.6-6.2-4V385z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.9,328.4V339c1.8-1.8,3.8-3.6,6.2-5.4v-5.2H344.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M345.9,322.2c-0.4,0.2-0.6,0.4-1,0.6v5.4h6.2h7.8c3.6-2.2,7.6-4.2,11.8-6.2L345.9,322.2L345.9,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M589.7,322.2h-24c4.2,2,8,4,11.4,6.2h19.8C594.7,326.2,592.3,324.2,589.7,322.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M537.1,432.8c-19.8,3.6-40.2,5.6-60.8,5.8l0,0C496.9,438.4,517.5,436.4,537.1,432.8L537.1,432.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.7,443c-12.6,1.2-25.6,2-38.4,2c0,0.4-0.4,0.8-0.2,1.2c0.6,2.8,2.8,4.6,5.4,4.8c0.8,0,1.6,0,2.4,0 C489.1,448.8,499.3,446.2,509.7,443z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.7,443c9-2.8,18.2-6.4,27.4-10.2c-19.8,3.6-40.2,5.6-60.8,5.8c-0.2,0-0.4,0-0.6,0.2c-3,0.6-4.6,3.2-4.6,6 C484.1,444.8,496.9,444.2,509.7,443z"
}), React.createElement("path", {
  className: "st1",
  d: "M619.1,847c-2,0.8-4.2,1.8-6.2,2.6C614.9,848.8,616.9,848.01,619.1,847z"
}), React.createElement("path", {
  className: "st1",
  d: "M629.9,842.6c5.8-2.6,11.4-5.4,16.6-8.4c5-3,9.8-6,14.4-9.2c-4.6,3.2-9.4,6.2-14.4,9.2 C641.1,837.2,635.5,840,629.9,842.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M671.9,817c0.2-0.2,0.4-0.4,0.6-0.6c-2.6,2-5.2,4.2-8,6.2C666.9,820.6,669.5,818.8,671.9,817z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.9,856.6c5.6-1.6,11-3.2,16.2-5C601.7,853.2,596.3,855,590.9,856.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M611.1,850.2c0.6-0.2,1.2-0.4,1.8-0.6c2.2-0.8,4.2-1.6,6.2-2.6c2.4-1,4.6-1.8,6.8-2.8 C621.1,846.4,616.1,848.4,611.1,850.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M574.9,860.6c4.4-1,8.4-2.2,12.6-3.2c-4.6,1.2-9.4,2.2-14.2,3.4c0,0,0,0,0.2,0 C574.1,860.8,574.5,860.6,574.9,860.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M629.5,842.8C629.5,842.8,629.7,842.8,629.5,842.8c5.8-2.8,11.4-5.6,16.8-8.6 C641.1,837.2,635.3,840,629.5,842.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M567.5,849.4L567.5,849.4c2-0.4,4.2-0.8,6.2-1.2v-0.2C571.5,848.6,569.5,849.01,567.5,849.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M674.3,806.8c-2,1.8-4,3.4-6.2,5.2v0.2c-1.6,1.4-3.6,2.6-5.2,3.8c-1.8,1.4-3.6,2.6-5.4,4c-4.4,3-9,6-14,8.8 s-10.2,5.6-15.4,8c-0.6,0.2-1.2,0.6-2,0.8c-2,0.8-4,1.6-6,2.4c-3,1.2-5.8,2.6-8.8,3.6c-1.4,0.4-2.8,1-4.2,1.4 c-2.4,0.8-4.8,1.6-7.2,2.4c-2.2,0.6-4.2,1.4-6.6,2c-2,0.6-4.2,1-6.2,1.6c-2.6,0.6-5.2,1.4-7.8,2c-1.6,0.4-3.2,0.8-4.8,1.2 c-0.2,0-0.4,0.2-0.6,0.2l0,0c-2,0.4-4,0.8-5.8,1.2c0.2,1.4,1,2.8,2,3.6c1,0.8,2.4,1.2,3.6,1.4c4.8-1,9.6-2.2,14.2-3.4 c1-0.2,2.2-0.6,3.2-0.8c5.6-1.6,11-3.2,16.2-5c1.2-0.4,2.6-0.8,4-1.2c5.2-1.8,10-3.8,14.8-6c1.2-0.6,2.4-1,3.6-1.6 c5.8-2.6,11.4-5.6,16.8-8.6c5-3,9.8-6,14.4-9.2c1.2-0.8,2.4-1.8,3.6-2.6c2.8-2,5.4-4,8-6.2c1-1.2,1.8-2.6,1.8-4.2 C674.3,811.8,674.3,806.8,674.3,806.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M599.7,847.4c2.4-0.8,4.8-1.6,7.2-2.4c-1.6,0.6-3,1-4.6,1.4C601.5,846.8,600.7,847.2,599.7,847.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M579.1,853.2c2.6-0.6,5.2-1.4,7.8-2c-0.6,0.2-1,0.2-1.6,0.4C583.3,852,581.3,852.6,579.1,853.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M619.9,840c2-0.8,4-1.6,6-2.4c-1.8,0.8-3.8,1.6-5.6,2.4C620.1,840,620.1,840,619.9,840z"
}), React.createElement("path", {
  className: "st1",
  d: "M593.3,849.6c2.2-0.6,4.4-1.4,6.6-2c-0.2,0-0.2,0-0.4,0.2C597.3,848.2,595.3,849.01,593.3,849.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M611.1,843.6c3-1.2,5.8-2.4,8.8-3.6l0,0C616.9,841.21,614.1,842.6,611.1,843.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M567.7,855.6L567.7,855.6c2-0.4,4-0.8,5.8-1.2v-0.2C571.7,854.8,569.7,855.2,567.7,855.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M643.3,828.8c-5,2.8-10.2,5.6-15.4,8C633.1,834.4,638.3,831.6,643.3,828.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M574.3,854.4c1.6-0.4,3.2-0.8,4.8-1.2c-0.4,0-0.8,0.2-1,0.2C576.7,853.8,575.5,854.01,574.3,854.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M567.5,854.6c0,0.4,0.2,0.8,0.2,1.2c2-0.4,4-0.8,5.8-1.2v-6.2c-2,0.4-4.2,0.8-6.2,1.2v5H567.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.7,816c-1.8,1.4-3.6,2.6-5.4,4C659.3,818.6,660.9,817.2,662.7,816z"
}), React.createElement("path", {
  className: "st1",
  d: "M599.3,847.6c0.2,0,0.2,0,0.4-0.2c0.8-0.2,1.8-0.6,2.6-0.8C601.3,846.8,600.3,847.2,599.3,847.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M668.1,804.01v7.8c2.2-1.6,4.2-3.4,6.2-5.2v-8.4C672.3,800.2,670.3,802.2,668.1,804.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M578.1,853.4c0.4,0,0.8-0.2,1-0.2c2.2-0.6,4.2-1,6.2-1.6C582.9,852.2,580.5,852.8,578.1,853.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M619.9,840L619.9,840c0.2,0,0.2-0.2,0.4-0.2C620.1,840,620.1,840,619.9,840z"
}), React.createElement("path", {
  className: "st1",
  d: "M640.1,415.4c-9,5.2-18.8,9.8-29,14C621.3,425.2,631.1,420.6,640.1,415.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M658.7,403.2c-1.4,1-2.8,2.2-4.2,3.2C655.9,405.4,657.3,404.2,658.7,403.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M606.1,431.6c-10,4-20.4,7.4-31.4,10.4C585.5,439,596.1,435.6,606.1,431.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M674.3,404c0-1.4-0.6-2.8-1.6-3.8c-3,2.6-6.2,5-9.6,7.6c1.6-1.2,3.4-2.4,5-3.8v7.6c2.2-1.6,4.2-3.2,6.2-4.8 V404z"
}), React.createElement("path", {
  className: "st1",
  d: "M612.7,435.4c-1.4,0.6-2.8,1.2-4.2,1.8C609.9,436.8,611.3,436,612.7,435.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M658.1,411.2c-4.6,3.2-9.6,6.4-14.8,9.4C648.5,417.6,653.5,414.4,658.1,411.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M576.5,447.8c-3,0.8-6,1.6-9.2,2.4v6.2c2-0.6,4-1.2,6.2-1.6v-6.2C574.7,448.6,575.5,448.01,576.5,447.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M670.7,398.4c-2.2-1-4.6-0.8-6.4,0.8c-1.8,1.4-3.8,2.8-5.6,4c-1.4,1-2.8,2.2-4.2,3.2c-4.6,3.2-9.2,6.2-14.2,9 c-9,5.2-18.8,9.8-29,14c-1.8,0.8-3.4,1.4-5.2,2.2c-10,4-20.6,7.4-31.4,10.4c-1,0.2-1.8,0.6-2.6,0.8c-2.8,0.8-4.6,3.2-4.6,6v1.4 c3-0.8,6-1.6,9.2-2.4c11-3,21.6-6.4,32-10.6c1.4-0.6,2.8-1.2,4.2-1.8c10.6-4.4,21-9.2,30.6-14.8c5.2-3,10.2-6.2,14.8-9.4 c1.6-1.2,3.2-2.4,4.8-3.6c3.4-2.4,6.6-5,9.6-7.6C672.1,399.4,671.5,398.8,670.7,398.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M622.5,832.4c0.4-0.2,0.6-0.2,1-0.4c0,0,0,0,0.2,0C623.1,832,622.7,832.2,622.5,832.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M659.5,810.8c-6,4.4-12.2,8.8-19.2,12.8C647.1,819.4,653.5,815.2,659.5,810.8z"
}), React.createElement("polygon", {
  className: "st1",
  points: "604.9,839.2 605.1,839.2 605.1,839.2  "
}), React.createElement("path", {
  className: "st1",
  d: "M618.5,439.8c-2,0.8-4.2,1.8-6.2,2.6C614.3,441.6,616.3,440.6,618.5,439.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M623.3,832c0.8-0.4,1.8-0.8,2.8-1.2C625.3,831.21,624.3,831.4,623.3,832C623.5,831.8,623.5,832,623.3,832z"
}), React.createElement("path", {
  className: "st1",
  d: "M605.1,839.2c2-0.6,4-1.4,6-2C609.1,837.8,607.1,838.4,605.1,839.2L605.1,839.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M595.1,842.6c-3,0.8-6,1.6-9,2.6C589.1,844.2,592.1,843.4,595.1,842.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M573.7,848.2c1.8-0.4,3.4-0.8,5-1.2C577.1,847.4,575.3,847.6,573.7,848.2L573.7,848.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M657.3,820c-4.4,3-9,6-14,8.8C648.3,826,652.9,823.01,657.3,820z"
}), React.createElement("path", {
  className: "st1",
  d: "M668.1,812L668.1,812c-1.8,1.2-3.4,2.6-5.2,3.8C664.5,814.6,666.5,813.4,668.1,812z"
}), React.createElement("path", {
  className: "st1",
  d: "M586.9,851.21c2-0.6,4.2-1,6.2-1.6c-2,0.6-4,1-6,1.6C587.1,851,587.1,851.21,586.9,851.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M606.9,845c1.4-0.4,2.8-0.8,4.2-1.4c-1.2,0.4-2.6,0.8-3.8,1.2C607.3,845,607.1,845,606.9,845z"
}), React.createElement("path", {
  className: "st1",
  d: "M625.9,837.6c0.6-0.2,1.2-0.6,2-0.8C627.3,837,626.7,837.2,625.9,837.6C626.1,837.6,625.9,837.6,625.9,837.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M573.7,854.6c0.2,0,0.4-0.2,0.6-0.2C574.1,854.4,573.9,854.4,573.7,854.6L573.7,854.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M620.3,840c1.8-0.8,3.8-1.4,5.6-2.4h0.2C624.3,838.4,622.3,839.2,620.3,840z"
}), React.createElement("path", {
  className: "st1",
  d: "M585.5,851.6c0.6-0.2,1-0.2,1.6-0.4c0.2,0,0.2,0,0.2,0C586.7,851.21,586.1,851.4,585.5,851.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M602.3,846.6c1.6-0.6,3-1,4.6-1.4c0.2,0,0.2-0.2,0.4-0.2C605.7,845.4,604.1,846,602.3,846.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M618.9,833.8c1.4-0.6,3-1.2,4.4-2c-0.4,0.2-0.6,0.2-1,0.4C621.3,832.8,620.1,833.4,618.9,833.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M578.7,847c0.4,0,0.8-0.2,1-0.2l0,0C579.5,846.8,579.1,846.8,578.7,847z"
}), React.createElement("path", {
  className: "st1",
  d: "M582.9,845.8c-1,0.2-2,0.6-3,0.8C580.9,846.4,581.9,846.21,582.9,845.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M599.7,841c1.8-0.6,3.6-1.2,5.2-1.8l0,0C603.3,839.8,601.5,840.4,599.7,841z"
}), React.createElement("path", {
  className: "st1",
  d: "M587.3,851c2-0.6,4-1,6-1.6c2-0.6,4-1.4,6.2-2C595.5,848.8,591.3,850,587.3,851z"
}), React.createElement("path", {
  className: "st1",
  d: "M627.9,836.8c5.4-2.4,10.6-5.2,15.4-8c-5.4,3.2-11.2,6-17.2,8.6C626.7,837.2,627.3,837,627.9,836.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M573.7,854.4L573.7,854.4c0.2,0,0.4,0,0.6,0c1.2-0.2,2.6-0.6,3.8-1C576.7,853.8,575.1,854.01,573.7,854.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M607.3,844.8c1.2-0.4,2.6-0.8,3.8-1.2c3-1.2,5.8-2.4,8.8-3.6C615.7,841.8,611.7,843.4,607.3,844.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M661.9,808.8L661.9,808.8c-0.8,0.8-1.8,1.2-2.6,1.8c-6,4.4-12.2,8.8-19.2,12.8c-4.4,2.6-9.2,5-14,7.2 c-0.8,0.4-1.8,0.8-2.8,1.2c-1.4,0.6-3,1.2-4.4,2c-2.6,1.2-5.2,2.2-7.8,3.2c-2,0.8-4,1.4-6,2c-1.8,0.6-3.4,1.2-5.2,1.8 c-1.6,0.6-3,1-4.6,1.6c-3,1-6,1.6-9,2.6c-1,0.2-2,0.6-3,0.8c-1,0.2-2,0.6-3,0.8h-0.2l0,0c-0.4,0-0.8,0.2-1,0.2 c-1.6,0.4-3.4,0.8-5,1.2v6.2c1.4-0.4,3-0.6,4.4-1c2.4-0.6,4.8-1.2,7.4-1.8c0.6-0.2,1.2-0.4,1.8-0.4c4.2-1.2,8.2-2.2,12.2-3.6 c1-0.4,2-0.6,3-1c1.6-0.6,3.4-1,5-1.6c4.2-1.6,8.4-3.2,12.6-4.8c0.2,0,0.2-0.2,0.4-0.2c2-0.8,4-1.6,5.8-2.4 c6-2.6,11.8-5.6,17.2-8.6c5-2.8,9.6-5.8,14-8.8c1.8-1.4,3.6-2.6,5.4-4c1.8-1.4,3.6-2.6,5.2-4v-7.8 C666.1,805.6,663.9,807.2,661.9,808.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M668.1,404c-1.6,1.2-3.4,2.4-5,3.8c-1.6,1.2-3.2,2.4-4.8,3.6c-4.6,3.2-9.6,6.4-14.8,9.4 c-9.6,5.6-20,10.4-30.6,14.8c-1.4,0.6-2.8,1.2-4.2,1.8c-10.2,4-21,7.6-32,10.6c-1,0.2-2,0.8-3,1v6.2c3-0.8,6-1.6,9-2.4 c10.2-3,20.2-6.4,29.6-10.2c2.2-0.8,4.2-1.8,6.2-2.6c9.8-4.2,19.2-8.6,28-13.6c8-4.6,15-9.4,21.8-14.6v-7.8 C668.3,404,668.1,404,668.1,404z"
}), React.createElement("path", {
  className: "st1",
  d: "M663.1,407.6c-1.6,1.2-3.2,2.4-4.8,3.6C659.9,410,661.5,408.8,663.1,407.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M643.3,420.8c-9.6,5.6-20,10.4-30.6,14.8C623.3,431,633.7,426.2,643.3,420.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.5,437.2c-10.2,4-21,7.6-32,10.6C587.5,444.8,598.3,441.4,608.5,437.2z"
}));

var SvgCoffeeIcon = function SvgCoffeeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCoffeeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Coffee_Icon.6fa90639.svg";
export { ForwardRef as ReactComponent };